import i18n from "i18next";
import { initReactI18next } from "react-i18next";

let locale = localStorage.getItem("lang") || navigator.language || navigator.userLanguage;

// ko-KR → ko 이런 식으로 1차 정리
if (locale.includes("-")) {
    locale = locale.split("-")[0];
}

switch (locale) {
    case "ko":
        locale = "ko";
        break;
    case "en":
        locale = "en";
        break;
    case "mn":
        locale = "mn";
        break;
    case "ru":
        locale = "ru";
        break;
    default:
        locale = "ko";
        break;
}

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: require("./locales/en.json")
        },
        ko: {
            translation: require("./locales/ko.json")
        },
        ru: {
            translation: require("./locales/ru.json")
        },
        mn: {
            translation: require("./locales/mn.json")
        }
    },
    lng: locale,
    fallbackLng: "ko",
    interpolation: {
        escapeValue: false
    }
});

export default i18n;
